import type { IntlShape } from 'react-intl/src/types';
import type { InferType } from 'yup';
import { bool, object, string } from 'yup';

import { EMAIL_REGX } from '@/lib/forms/const';
import { passwordSchema } from '@/lib/forms/schemas';
import { formMessages } from '@/messages/forms';

export type LoginSchema = InferType<ReturnType<typeof loginSchema>>;

export const loginSchema = (
  formatMessage: IntlShape['formatMessage'],
  needCaptcha: boolean,
) => {
  const requiredMsg = formatMessage(formMessages.requiredField);

  if (needCaptcha) {
    return object({
      email: string()
        .required(requiredMsg)
        .matches(EMAIL_REGX, formatMessage(formMessages.invalidEmailAddress))
        .default(''),
      captcha: bool()
        .default(false)
        .oneOf([true], formatMessage(formMessages.requiredField)),
    }).shape(passwordSchema(formatMessage, false));
  } else {
    return object({
      email: string()
        .required(requiredMsg)
        .matches(EMAIL_REGX, formatMessage(formMessages.invalidEmailAddress))
        .default(''),
      captcha: bool().default(false).notRequired(),
    }).shape(passwordSchema(formatMessage, false));
  }
};
